<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>Recursos de Aprendizagem</h4></v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-list two-line class="pa-0">
        <template v-for="(item, index) in this.list">
          <v-divider :key="index"></v-divider>
          <v-list-item
            avatar
            :key="item.id"
            :id="'aqui-' + item.id"
            @click="handleClick(item, $event)"
          >
            <v-list-item-avatar>
              <v-icon x-medium>picture_as_pdf</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
              <v-list-item-subtitle
                v-html="item.file_name"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import axios from "axios";
export default {
  props: {
    list: {
      required: true,
    },
  },
  data: () => ({
    // list: []
  }),
  mounted() {
    // this.list = this.props.list
  },
  methods: {
    handleClick: (item, e) => {
      axios
        .post(
          "/courses/resources/" + item.id + "/download",
          {},
          { responseType: "blob" },
        )
        .then((response) => {
          const blob = new Blob([response.data], { type: item.mime_type });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = item.file_name;
          link.click();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateList() {
      this.list = [];
      await this.$nextTick();
    },
  },
};
</script>
